import * as Sentry from '@sentry/react';
import { createBrowserRouter, Navigate, RouterProvider, useLocation, useParams } from 'react-router';

import { ROUTE_PATHS } from './route-paths';
import { LocalRecordingRecovery } from '@/conference/local-recording';
import { CustomPage } from '@/pages/custom/custom-page';
import { EgressPage } from '@/pages/egress/egress-page';
import { HomePage } from '@/pages/home/home-page';
import { RecordingsPage } from '@/pages/recordings/recordings-page';
import { SharedRecordingPage } from '@/pages/recordings/shared-recording-page';
import { RoomPage } from '@/pages/room/room-page';

function LegacyRoomRedirect() {
    const { roomName = '' } = useParams();
    const { search, hash } = useLocation();
    return <Navigate replace to={`/${encodeURIComponent(roomName)}${search}${hash}`} />;
}

const router = Sentry.wrapCreateBrowserRouter(createBrowserRouter)([
    { path: ROUTE_PATHS.home, element: <HomePage /> },
    { path: ROUTE_PATHS.recordings, element: <RecordingsPage /> },
    { path: ROUTE_PATHS.sharedRecording, element: <SharedRecordingPage /> },
    { path: ROUTE_PATHS.custom, element: <CustomPage /> },
    { path: ROUTE_PATHS.legacyRoom, element: <LegacyRoomRedirect /> },
    { path: ROUTE_PATHS.egressTemplate, element: <EgressPage /> },
    { path: ROUTE_PATHS.room, element: <RoomPage /> },
]);

export function App() {
    return (
        <>
            <RouterProvider router={router} />
            <LocalRecordingRecovery />
        </>
    );
}
